import React, { useEffect, useState } from "react";
import { InputTrim } from "../InputTrim/InputTrim";
import { deleteWhiteSpace, regexOnlyNumbers } from "../../helpers/helpers";

const clearInputText = (text) => {
  const cleanText = deleteWhiteSpace(text);
  if (regexOnlyNumbers.test(Number(cleanText))) return cleanText;
  return "";
};

export const CalcInput = ({
  id,
  readOnly,
  maxLength,
  selected,
  tempSelected,
  items,
  formatValue,
  onSelect,
  className,
  isDisabled,
}) => {
  const valueFormatted = formatValue(selected);
  const [text, setText] = useState(valueFormatted);

  const select = (item) => {
    if (!item) return;
    setText(formatValue(item));
    onSelect(item);
  };

  const validateAndGet = (number, periodTypeId = null) => {
    // ищем значение среди доступных. либо берем то, что выше на шаг (значения отсортированы по возрастанию)
    let item = items.find(
      (i) =>
        i.number >= number && (!periodTypeId || i.periodTypeId === periodTypeId)
    );
    // если выходим за границы значений, присваиваем граничное
    if (!item) {
      if (number < items[0].number) {
        [item] = items; // значение ниже минимального, присваиваем минимальное
      } else if (number > items[items.length - 1].number) {
        item = items[items.length - 1]; // значение выше максимального, берем максимальное
      }
    }
    return item;
  };

  // пользовательские изменения в текстовом поле суммы
  const onInputChanged = (inputText) => {
    const cleanText = clearInputText(inputText);
    if (cleanText) {
      const number = Number(cleanText);
      const item = validateAndGet(number);
      if (item) select(item);
    }
  };

  // слушаем внешние изменения и меняем значение в текстовом поле
  useEffect(() => {
    // валидируем внешнее значение
    if (selected) {
      const item = validateAndGet(selected.number, selected.periodTypeId);
      if (item && item.number !== selected.number) {
        // если оно невалидно, устанавливаем новое
        select(item);
        return;
      }
    }

    // устанавливаем внешнее значение, прошедшее валидацию
    const newText = selected ? formatValue(selected) : "";
    if (text !== newText) {
      setText(newText);
    }
  }, [selected]);

  // слушаем внешние НЕПРИМЕНЕННЫЕ изменения и меняем значение в текстовом поле
  useEffect(() => {
    const newText = tempSelected ? formatValue(tempSelected) : "";
    if (text !== newText) {
      setText(newText);
    }
  }, [tempSelected]);

  const handleInput = (e) => {
    const { value } = e.target;
    const integerValue = +value.replace(/[^+\d]/g, "");
    setText(integerValue);
  };

  return (
    <InputTrim
      id={id}
      readOnly={readOnly} // не давать редактировать поле,  пока не прогрузились дефолтные значения
      maxLength={maxLength}
      value={text}
      onChange={handleInput}
      onBlur={(e) => onInputChanged(e.target.value)}
      className={className}
      isDisabled={isDisabled}
    />
  );
};
